<script>
export default {
  name: 'SelectCoeff',
  data(){
    return{
      coeffs: [],
      selectedCoeff: "",
    }
  },
  mounted(){
    this.$axios.get('coeffLabels/getActive/' + this.$store.state.auth.currentAgence._id)
      .then(response => {
        this.coeffs = response.data
        //Par défaut je regarde s'il y a un coefficient favori. Sinon je prends le premier de la liste.
        this.selectedCoeff = this.$store.state.auth.currentUser.coefficientFavori || this.coeffs[0]._id
        //Si le favoris ne correspond pas à un élément de la liste (le coeff correspondant à été désactivé ou supprimé), je prends le premier de la liste
        if (this.coeffs.find(e => e._id == this.selectedCoeff) == undefined){
          this.selectedCoeff = this.coeffs[0]._id
        }

        this.changeCoeff()
      })
      .catch(err => this.alert(err))
  },
  methods:{
    //Ajouter la valeur du coeff sélectionné dans le store (puisque mais éléments interdépendants sont parfois dans la même vue, parfois dans des vue différentes, je passe par le store à chaque fois)
    changeCoeff(){
        this.$store.state.auth.currentCoeff = this.selectedCoeff
    }
  }
}
</script>


<template>
  <div class="coeffs">
    <div class="coeffs__title">Coefficient utilisé</div>
    <div v-for="item in coeffs" :key="item._id">
        <input type="radio" :id="item._id" name="selectedCoeff" v-model="selectedCoeff" :value="item._id" @change="changeCoeff()">
        <label class="coeffs__label" :for="item._id"> {{item.name}} </label>
    </div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.coeffs{
  @include myBlock;
  padding: 15px;

  &__title{
    @include myFont;
    color: $main;
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 10px 0;
  }

  &__label{
    @include myFont;
    color: $black-bolder;
    font-size: 13px;
    vertical-align: text-top;
  }
}

</style>
